import * as React from 'react';
import { EMAIL_REGEX } from '@medflex/shared-utils';
import * as PropTypes from 'prop-types';
import queryString from 'query-string';
import { Redirect } from 'react-router-dom';
import * as yup from 'yup';
import Logger from '@medflex/utils/Logger';
import config from '@medflex/utils/config';
import useLocationSearchParams from '../../hooks/useLocationSearchParams';

const schemaEmail = yup.object().shape({
  vorname: yup.string().trim().required(),
  nachname: yup.string().trim().required(),
  email: yup.string().matches(EMAIL_REGEX).required(),
});

const InvitePatientRedirectRoute = () => {
  const { vorname = '', nachname = '', email = '' } = useLocationSearchParams();

  let search = '';

  try {
    const invitePatientUri = {
      invitePatient: 'email',
      vorname,
      nachname,
      email,
    };
    schemaEmail.validateSync(invitePatientUri);
    search = queryString.stringify(invitePatientUri, { sort: false });
  } catch (e) {
    if (config.DEBUG === '1') Logger.warn('[InvitePatientRedirectRoute] -> ERROR', e.message);
  }

  return <Redirect push to={{ pathname: '', search }} />;
};

InvitePatientRedirectRoute.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default InvitePatientRedirectRoute;
